<script setup lang="ts">
  import ProductRow from './search-result-product-row.vue'

  defineProps<{
    type: 'sewa' | 'jual',
    products: Product[],
  }>()
</script>

<template>
  <product-row
    v-for="product in products"
    :key="product.id"
    :product="product"
    :type="type" />
</template>
